import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DOCUMENT_TYPE_CONFIG_BY_COMMUNITY } from "./apiRoutes";

interface UseGetDocTypeDropdownProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDocumentTypeDropdown = async (communityId: string) =>
  await axiosAuth.get(
    `${DOCUMENT_TYPE_CONFIG_BY_COMMUNITY(communityId)}/dropdown`
  );

const useGetDocumentTypeDropdown = ({
  communityId,
  queryParams,
}: UseGetDocTypeDropdownProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["document-type", communityId],
    queryFn: () => getDocumentTypeDropdown(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetDocumentTypeDropdown;
